import type { AdministratieRow, LimosaBadge as Badge, LimosaVerplichtBron } from '@/api/administratie';

const STYLE: Record<Badge, { label: string; className: string }> = {
  groen: { label: 'Geldig', className: 'bg-green-100 text-green-800 border-green-200' },
  oranje: { label: 'Vervalt binnenkort', className: 'bg-orange-100 text-orange-800 border-orange-200' },
  rood: { label: 'Ontbreekt', className: 'bg-red-100 text-red-700 border-red-200' },
  te_controleren: { label: 'Te controleren', className: 'bg-blue-100 text-blue-800 border-blue-200' },
  niet_nodig: { label: 'Niet nodig', className: 'bg-gray-100 text-gray-500 border-gray-200' },
};

function formatDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}

/** The Limosa cell: a status badge that opens the review dialog, also when the status is unknown. */
export function LimosaBadge({ row, onOpen }: { row: AdministratieRow; onOpen: (row: AdministratieRow) => void }) {
  if (row.installerId == null) return <span className="text-td-light">—</span>;
  // The status could not be read; the dialog loads its own data, so review and upload stay possible.
  if (row.limosa == null) {
    return (
      <button
        type="button"
        onClick={() => onOpen(row)}
        title="Status kon niet gelezen worden"
        className="inline-flex items-center px-2.5 py-1 text-xs font-semibold rounded-full border whitespace-nowrap hover:brightness-95 bg-gray-50 text-td-light border-gray-200"
      >
        Onbekend
      </button>
    );
  }
  const { label, className } = STYLE[row.limosa.badge];
  const title = row.limosa.geldigTot ? `${label} — geldig tot ${formatDate(row.limosa.geldigTot)}` : label;
  return (
    <button
      type="button"
      onClick={() => onOpen(row)}
      title={title}
      className={`inline-flex items-center px-2.5 py-1 text-xs font-semibold rounded-full border whitespace-nowrap hover:brightness-95 ${className}`}
    >
      {label}
      {row.limosa.badge === 'oranje' && row.limosa.geldigTot && (
        <span className="ml-1 font-normal">t/m {formatDate(row.limosa.geldigTot)}</span>
      )}
    </button>
  );
}

export { formatDate };

/** Where "Limosa verplicht" comes from, in words: manueel, or automatically from the company's country. */
export function verplichtBronLabel(b: LimosaVerplichtBron): string {
  switch (b.bron) {
    case 'manueel': return `manueel: ${b.keuze === 'ja' ? 'verplicht' : 'niet verplicht'}`;
    case 'buitenland': return `automatisch: buitenland (${b.land})`;
    case 'belgie': return 'automatisch: België';
    default: return 'automatisch: land onbekend';
  }
}
